import React, { useEffect, useRef, useState } from 'react'
import { getSizedImageUrl } from '../../../../../scripts/utils/image'
import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder'
import YellowUnderline from '../svgs/YellowUnderline'
import GreyBoxYellowBoxSwitcheroo from './GreyBoxYellowBoxSwitcheroo'

interface Props {
  onClose: () => void
}

const Calculator: React.FunctionComponent<Props> = ({onClose}) => {
  const { settings } = useSubBuilder()

  const [selectedIndex, setSelectedIndex] = useState(-1)

  const firstButton = useRef(null)

  const pressEscAction = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose()
    }
  }
  useEffect(() => {
    document.addEventListener('keydown', pressEscAction)
    firstButton.current.focus()
    return () => document.removeEventListener('keydown', pressEscAction)
  }, [])

  return <>
    <div className="calculator-wrap">
      <div className="calculator-underlay" onClick={onClose}></div>
      <aside className="calculator">
        <button onClick={onClose} className="calculator-close-top"></button>
        <div className="calculator-content">
          <h4 className="heading-3 calculator-title relative">
            {settings.steps.calculator.strings.title}
            <YellowUnderline />
          </h4>
          <p className="calculator-intro">
            { settings.steps.calculator.strings.intro }
          </p>
          <ul className="calculator-option-list">
            {settings.steps.calculator.options.map((option, i) => (
              <li className="calculator-option" key={i}>
                <button  ref={ i === 0 ? firstButton : null} className={`calculator-option-btn ${selectedIndex === i ? 'is-active' : ''}`} onClick={() => setSelectedIndex(i)} >
                  <GreyBoxYellowBoxSwitcheroo>
                    <img className="calculator-option-image" src={getSizedImageUrl(option.image, '140x140')} alt={option.title} data-lazy-load />
                  </GreyBoxYellowBoxSwitcheroo>
                </button>
              </li>
            ))}
          </ul>
          <footer className="calculator-footer">
            {selectedIndex > -1 &&
          <div className="calculator-helper">
            <div className="calculator-helper-label">
              {settings.steps.calculator.strings.helperTextLabel}
            </div>
            <div className="calculator-helper-text">
              {settings.steps.calculator.options[selectedIndex].helperText}
            </div>
          </div>
            }
            <div className="calculcator-close-wrap">
              <button className="btn btn--secondary" onClick={onClose}>{ settings.steps.calculator.strings.closeText }</button>
            </div>
          </footer>
        </div>
        
      </aside>
    </div>
  </>
}
interface Props {
  open: boolean
}


export default Calculator